<template lang="pug">
  div
    .columns
      .column.is-8
          b {{ categoriaSel.nombre }}
          | &nbsp
      .column.is-4
        a.button.is-primary.is-rounded.is-small(@click="newSunCat()" v-show="!agregandoSub && !editandoSub")
          i.fas.fa-plus
          | &nbspSubCategoría
    .columns
      .column.is-2
        span.tag Area: {{ categoriaSel.area === "s" ? 'Sistemas' : categoriaSel.area === "i" ? 'Instrumentacion' : 'Administracion' }} 
      .column.is-2
        span.tag(:class="categoriaSel.isConsumible == 1 ? 'is-danger' : ''") {{ categoriaSel.isConsumible == 1 ? 'Consumible' : 'No es consumible' }}
    .columns
      .column.is-12(v-show='agregandoSub || editandoSub')
        NewSubCate(@closeFormSubs="cerrarFormularioSubs" v-show="agregandoSub" :categoria="categoriaSel")
        EditSubCate(@closeFormEditSubs="cerrarFormularioEditSubs" v-show="editandoSub" :subcategoria="subcategoriaSel")
      .column.is-12(v-show="hayDatos && !agregandoSub && !editandoSub")
        div
          div(v-for="(data, index) in subcategorias" :key="data.id")
            span.tag.is-warning.is-medium(@click="mostrarSubCat(data, index)")
              | {{ data.nombre }}
              button.delete.is-small(@click="eliminarSubCat(data)")
    .columns(v-show='!agregandoSub && !editandoSub')
      .column.is-4(v-show="!hayDatos")
        .notification.is-danger No existen Registros aún en la Base de Datos.
</template>

<script>
import InventarioServices from '../../services/inventario/inventario';
import NewSubCate from '@/components/inventario_Componentes/NewSubCate.vue'
import EditSubCate from '@/components/inventario_Componentes/EditSubCate.vue'

export default {
  name: 'ListSubCategorias',
  components: { NewSubCate, EditSubCate },
  props: {
    categoriaSel: {}
  },
  watch: {
    categoriaSel () {
      this.obtenerSubcategorias()
    }
  },
  data () {
    return {
      isLoading: true,
      hayDatos: false,
      subcategorias: [],
      agregandoSub: false,
      editandoSub: false,
      subcategoriaSel: {}
    }
  },
  methods: {
    obtenerSubcategorias () {
      InventarioServices.getSubcategorias(this.categoriaSel.id)
        .then(res => {
          console.log(res.data)
          if (res.data.length > 0) {
              this.subcategorias = res.data
              this.isLoading = false
              this.hayDatos = true
          } else {
            this.isLoading = false
            this.hayDatos = false
          }
        })
    },
    newSunCat () {
      this.agregandoSub = true
    },
    cerrarFormularioSubs () {
      this.agregandoSub = false
      this.obtenerSubcategorias()
    },
    cerrarFormularioEditSubs() {
      this.editandoSub = false
      this.obtenerSubcategorias()
    },
    mostrarSubCat (subcat, index) {
      this.subcategoriaSel = subcat
      this.editandoSub = true
    },
    eliminarSubCat (subcat) {
      console.log(subcat)
    },
    copiarId (id) {
      if (!navigator.clipboard) {
        console.log('NO se puede')
        return;
      }
      navigator.clipboard.writeText(id)
        .then( () => {
          console.log('copiado')
        })
        .catch( e => {
          console.log(e.message)
        })

    }
  }
}
</script>

<style scoped>
  #panelCats {
    height: 458px;
    border: 1px solid #00d1b2;
    background: #ffffff;
    overflow-y: scroll;
  }

  .panel-block {
    border: 1px solid #00d1b2;
  }

  a.panel-block.itemsCats:hover {
    background-color: #c7faf2;
    color: #00d1b2;
  }

  a.panel-block.itemsCats.is-active {
    background-color: #00d1b2;
    color: #ffffff;
  }

  .panel-heading:first-child, .panel-tabs:first-child, .panel-block:first-child {
    border-top: #00d1b2;
  }
  
  .panel-block.is-active .panel-icon {
    color: #ffffff;
  }

  span.tag.is-warning.is-medium {
    margin-bottom: 5px; 
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/ListSubCategorias.vue